import { Box, Flex, Icon, Text } from '@/ui';
import type { IconName } from '@/ui/Icon/Icon';

type Props = {
  icon: IconName;
  name: string;
  subtitle: string;
  /**
   * The viewer's role in this workspace, folded into the subtitle line rather
   * than badged — a badge costs width the account name needs more.
   */
  role?: string;
  isActive: boolean;
  onClick: () => void;
};

// A richer sidebar row than Tab: an org-type icon chip over the account name and
// a "<role> · <type>" detail line. Used for the Accounts & Workspaces list.
export const AccountListItem = ({
  icon,
  name,
  subtitle,
  role,
  isActive,
  onClick,
}: Props) => (
  <Flex
    _hover={{ bg: 'gray.200' }}
    align="center"
    as="button"
    bg={isActive ? 'gray.200' : 'transparent'}
    borderRadius="md"
    gap="3"
    px="3"
    py="2.5"
    textAlign="left"
    type="button"
    w="100%"
    onClick={onClick}
  >
    <Flex
      align="center"
      bg="white"
      borderColor="gray.200"
      borderRadius="md"
      borderWidth="1px"
      boxSize="9"
      flexShrink={0}
      justify="center"
    >
      <Icon icon={icon} size="4" />
    </Flex>

    <Box flex="1" lineHeight="short" minW="0">
      {/* Two lines before truncating: workspace names are user-chosen and often
          too long for one, and the row no longer spends width on a badge. */}
      <Text fontSize="sm" fontWeight="semibold" noOfLines={2}>
        {name}
      </Text>
      <Text color="customgray.mid" fontSize="xs" noOfLines={1}>
        {role && (
          <>
            <Text as="span" color="ink.soft" fontWeight="semibold">
              {role}
            </Text>
            {' · '}
          </>
        )}
        {subtitle}
      </Text>
    </Box>
  </Flex>
);
